module.exports = __webpack_public_path__ + "public/images/share.22678cec9d8187e3775199c22917993c.png";